import { render } from "./importInStock.vue?vue&type=template&id=5f99bdec&scoped=true"
import script from "./importInStock.vue?vue&type=script&lang=js"
export * from "./importInStock.vue?vue&type=script&lang=js"

import "./importInStock.vue?vue&type=style&index=0&id=5f99bdec&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5f99bdec"

export default script